export const SET_CONTACTS = 'SET_CONTACTS';
export const ADD_CONTACT = 'ADD_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';

export const SET_NOTES = 'SET_NOTES';
export const ADD_NOTE = 'ADD_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';

export const SET_ATTACHED_FILES = 'SET_ATTACHED_FILES';
export const DELETE_ATTACHED_FILE = 'DELETE_ATTACHED_FILE';

export const SET_WEATHER = 'SET_WEATHER';

export const SET_MEETING_LOCATION = 'SET_MEETING_LOCATION';

export const SET_EQUIPMENT = 'SET_EQUIPMENT';
export const UPDATE_EQUIPMENT = 'UPDATE_JOB_EQUIPMENT';
export const DELETE_EQUIPMENT = 'DELETE_EQUIPMENT';

export const SET_CREW = 'SET_CREW';
export const UPDATE_CREW = 'UPDATE_CREW';
export const DELETE_CREW = 'DELETE_CREW';

export const SET_PEOPLE = 'SET_PEOPLE';
export const UPDATE_PEOPLE = 'UPDATE_PEOPLE';
export const DELETE_PEOPLE = 'DELETE_PEOPLE';

export const SET_LINE_TYPES = 'SET_LINE_TYPES';
export const ADD_LINE_TYPE = 'ADD_LINE_TYPE';
export const UPDATE_LINE_TYPE = 'UPDATE_LINE_TYPE';
export const DELETE_LINE_TYPE = 'DELETE_LINE_TYPE';

export const SET_ACTIVITY_LOG = 'SET_ACTIVITY_LOG';

export const SET_CURRENT_JOB_ID = 'SET_CURRENT_JOB_ID';

export const RESET_JOB_DASHBOARD = 'RESET_JOB_DASHBOARD';
